<template>
  <div align="center">
    <p>
      La página o recurso al que intentas acceder no fue encontrado en nuestro
      servidor o no tienes permiso de acceder a este.
    </p>
    <br />
    <br />
    <br />
    <br />
    <br />
    <v-img class="mx-auto" :width="500" src="/static/iconos/logo1.png"></v-img>
  </div>
</template>
